/* eslint-disable max-len */
import React from 'react';

export const ImageIcon = props => (
  <svg width="40px" height="40px" viewBox="0 0 40 40" {...props}>
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g transform="translate(-237.000000, -242.000000)">
        <g transform="translate(237.000000, 242.000000)">
          <g>
            <rect
              stroke="currentColor"
              strokeWidth="1"
              x="0.5"
              y="0.5"
              width="39"
              height="39"
              rx="1"
            />
            <path
              d="M-7.86056044,41.4999695 L-6.97651064,41.4999459 L-10.8685382,45.7745098 L38.8688493,45.7745098 L37.7088473,44.4999739 L49.888708,44.4999978 L47.2296743,41.4999359 L47.8975739,41.4999601 L31.8079656,23.1246751 C31.7077762,23.0462052 31.5858455,23.0117593 31.4667405,23.0196997 C31.3390627,23.0282115 31.2146322,23.0854308 31.1237117,23.18934 L25.2214193,29.9344868 L13.9791847,17.977415 C13.8513345,17.9827421 13.7255165,18.0368424 13.6320345,18.1384533 L-7.86056044,41.4999695 Z M29,7.5 C28.0334167,7.5 27.1584099,7.89169689 26.5250534,8.52505339 C25.8916969,9.15840989 25.5,10.0334167 25.5,11 C25.5,11.9752458 25.8995956,12.8572646 26.5740647,13.4894033 C27.239629,14.1131961 28.1696316,14.4917406 29.2419784,14.4917746 C29.9136222,14.4459287 30.5321673,14.2064001 31.1760788,13.7414192 C31.9827792,13.1003245 32.5,12.1106511 32.5,11 C32.5,10.0334167 32.1083031,9.15840989 31.4749466,8.52505339 C30.8415901,7.89169689 29.9665833,7.5 29,7.5 Z"
              stroke="currentColor"
              strokeWidth="1"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
);
